var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabbed-teaser-container" }, [
    (_vm.showCategoriesFilterParam || _vm.showCategoriesFilterParam != false) &&
    _vm.categories.length
      ? _c(
          "section",
          {
            staticClass: "categories-filter-section",
            class: {
              isEmpty:
                _vm.categories.length === 0 && _vm.categories.length === 0
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "categories-filter-section-inner container-fluid"
              },
              [
                _c("h2", { staticClass: "heading" }, [
                  _vm._v("\n                FINDE DEIN THEMA\n            ")
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "category-btn-listing clearfix" },
                  [
                    _vm._l(_vm.categories, function(category, categoryIndex) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-category btn-parent-category",
                            class: [
                              category.acf.category_color
                                ? "btn-" +
                                  category.acf.category_color.replace("#", "")
                                : "",
                              _vm.categoriesFilterParam.indexOf(category.id) >
                              -1
                                ? "active"
                                : ""
                            ],
                            style: [
                              category.acf.category_color
                                ? Object.assign(
                                    {},
                                    {
                                      "border-color":
                                        category.acf.category_color
                                    },
                                    _vm.activeCategories.includes(category.id)
                                      ? {
                                          "background-color":
                                            category.acf.category_color,
                                          color: "white"
                                        }
                                      : { color: category.acf.category_color }
                                  )
                                : {}
                            ],
                            attrs: {
                              to: category.link
                                .split("wp/")[1]
                                .replace(/\/$/, "")
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                "<img class='cross-icon' src='/img/ic_close_l_ffffff.svg'>" +
                                  category.name
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.setCategoriesFilterParam(category.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    >\n\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(category.children, function(
                          subCategory,
                          subCategoryIndex
                        ) {
                          return _c("a", {
                            key: _vm.index,
                            staticClass: "btn btn-category",
                            class: [
                              category.acf.category_color
                                ? "btn-" +
                                  category.acf.category_color.replace("#", "")
                                : "",
                              _vm.categoriesFilterParam.indexOf(
                                subCategory.id
                              ) > -1
                                ? "active"
                                : "",
                              _vm.categoriesFilterParamShowAll
                                ? ""
                                : "d-none d-md-block"
                            ],
                            style: [
                              category.acf.category_color
                                ? Object.assign(
                                    {},
                                    {
                                      "border-color":
                                        category.acf.category_color
                                    },
                                    _vm.activeCategories.includes(
                                      subCategory.id
                                    )
                                      ? {
                                          "background-color":
                                            category.acf.category_color,
                                          color: "white"
                                        }
                                      : { color: category.acf.category_color }
                                  )
                                : {}
                            ],
                            attrs: {
                              to: subCategory.link
                                .split("wp/")[1]
                                .replace(/\/$/, "")
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                "<img class='cross-icon' src='/img/ic_close_l_ffffff.svg'>" +
                                  subCategory.name
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.setCategoriesFilterParam(
                                  subCategory.id
                                )
                              }
                            }
                          })
                        })
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.teaserFilterParams.hasOwnProperty("categories") &&
                _vm.teaserFilterParams["categories"].length
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-category btn-reset-categories-filter-param",
                        on: {
                          click: function($event) {
                            return _vm.resetCategoriesFilterParam()
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "cross-icon",
                          attrs: { src: "/img/ic_close_l_ffffff.svg" }
                        }),
                        _vm._v("Auswahl zurücksetzen\n            ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "expand-collapse-link-container d-block d-md-none"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "expand-collapse-link",
                        on: {
                          click: function($event) {
                            return _vm.showHideAllCategoriesFilterParam()
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              "/img/ic_" +
                              (_vm.categoriesFilterParamShowAll
                                ? "minus"
                                : "plus") +
                              "_sm_000000.svg"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.categoriesFilterParamShowAll
                                ? "weniger Themen anzeigen"
                                : "mehr Themen laden"
                            )
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showTeaser
      ? _c(
          "section",
          {
            staticClass:
              "tabbed-teaser container-fluid tabbed-teaser-pink-white isLoaded"
          },
          [
            _c(
              "div",
              {
                staticClass: "tabbed-teaser-inner row row-eq-height",
                class: { "tabbed-teaser-inner-blank": !_vm.teaserHeading }
              },
              [
                _vm.teaserHeading
                  ? _c("h2", { staticClass: "heading" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.teaserHeading) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col col-12 text-right sort-btn-container" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default btn-sort",
                        class: { active: _vm.activeTab == "latest" },
                        on: {
                          click: function($event) {
                            return _vm.setOrderBy("latest")
                          }
                        }
                      },
                      [_vm._v("Neueste")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default btn-sort",
                        class: { active: _vm.activeTab == "ratings_average" },
                        on: {
                          click: function($event) {
                            return _vm.setOrderBy("ratings_average")
                          }
                        }
                      },
                      [_vm._v("Beliebteste")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab == "top",
                        expression: "activeTab == 'top'"
                      }
                    ],
                    staticClass: "col col-12"
                  },
                  [
                    _c("teaser-wide", {
                      attrs: {
                        "teaser-id": "latestTeaser",
                        "teaser-filter-params": _vm.tabbedTeaserFilterParam.top,
                        categories: _vm.categories,
                        "categories-filter-param": _vm.categoriesFilterParam,
                        "page-filter-param": _vm.page.top,
                        "order-by-param": "top"
                      },
                      on: { showLoadMore: _vm.onShowLoadMore }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab == "latest",
                        expression: "activeTab =='latest'"
                      }
                    ],
                    staticClass: "col col-12",
                    class: "cl-" + _vm.page.latest
                  },
                  [
                    _c("teaser-wide", {
                      attrs: {
                        "teaser-id": "latestTeaser",
                        "teaser-filter-params":
                          _vm.tabbedTeaserFilterParam.latest,
                        categories: _vm.categories,
                        "categories-filter-param": _vm.categoriesFilterParam,
                        "page-filter-param": _vm.page.latest,
                        "order-by-param": "latest"
                      },
                      on: { showLoadMore: _vm.onShowLoadMore }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab == "ratings_average",
                        expression: "activeTab =='ratings_average'"
                      }
                    ],
                    staticClass: "col col-12"
                  },
                  [
                    _c("teaser-wide", {
                      attrs: {
                        "teaser-id": "ratingsAverageTeaser",
                        "teaser-filter-params":
                          _vm.tabbedTeaserFilterParam.ratings_average,
                        categories: _vm.categories,
                        "categories-filter-param": _vm.categoriesFilterParam,
                        "page-filter-param": _vm.page.ratings_average,
                        "order-by-param": "ratings_average"
                      },
                      on: { showLoadMore: _vm.onShowLoadMore }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _vm.showLoadMoreButton.top > 0
              ? _c("load-more", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab == "top",
                      expression: "activeTab == 'top'"
                    }
                  ],
                  on: {
                    clicked: function($event) {
                      return _vm.loadMore()
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showLoadMoreButton.latest > 0
              ? _c("load-more", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab == "latest",
                      expression: "activeTab == 'latest'"
                    }
                  ],
                  on: {
                    clicked: function($event) {
                      return _vm.loadMore()
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showLoadMoreButton.ratings_average > 0
              ? _c("load-more", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab == "ratings_average",
                      expression: "activeTab == 'ratings_average'"
                    }
                  ],
                  on: {
                    clicked: function($event) {
                      return _vm.loadMore()
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28fc2192", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28fc2192","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/TabbedTeaser.vue
// module id = 629
// module chunks = 0